import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapMajorData } from './majorClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getMajors = (params: Majors.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Majors.Major>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/majors/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Majors.MajorApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapMajorData),
    },
  }));
};

const getMajor = (params: { id: number }): AxiosPromise<Majors.Major> => {
  return request({
    options: {
      url: `${apiBaseUrl}/majors/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Majors.MajorApi>) => ({
    ...data,
    data: mapMajorData(data.data),
  }));
};

const likeMajor = (params: { id: number }): AxiosPromise<Majors.Major> => {
  return request({
    options: {
      url: `${apiBaseUrl}/majors/${params.id}/favourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Majors.MajorApi>) => ({
    ...data,
    data: mapMajorData(data.data),
  }));
};

const unlikeMajor = (params: { id: number }): AxiosPromise<Majors.Major> => {
  return request({
    options: {
      url: `${apiBaseUrl}/majors/${params.id}/unfavourite/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Majors.MajorApi>) => ({
    ...data,
    data: mapMajorData(data.data),
  }));
};

const ignoreMajor = (params: { id: number }): AxiosPromise<Majors.Major> => {
  return request({
    options: {
      url: `${apiBaseUrl}/majors/${params.id}/ignore/`,
      method: 'POST',
    },
  }).then((data: AxiosResponse<Majors.MajorApi>) => ({
    ...data,
    data: mapMajorData(data.data),
  }));
};

export const majorClient = {
  getMajors,
  getMajor,
  likeMajor,
  unlikeMajor,
  ignoreMajor,
};
